import "./UploadStyles.scss";
import { IJSLComponent, IJSLVNode } from "jsl-render";
import { LoadingComponent, DateComponent } from "jsl-ui";
import { MyUploadsComponent } from "../../components/MyUploadsComponent";
import { FundModel } from "../../../ajax/types/FundModel";
import { ExpertController } from "../../../ajax/ExpertController";
import { FundOrtModel } from "../../../ajax/types/FundOrtModel";
import Axios from "axios";
import { refreshPendingCount, isInRole } from "../../../helper/ajax";
import { EditFundComponent } from "../../components/edit-fund/EditFundComponent";
import { CopyrightComponent } from "../../components/CopyrightComponent";
import { DateRangeComponent } from "jsl-ui/lib/components/date-range/DateRangeComponent";


export class UploadComponent implements IJSLComponent {

    private submitted: boolean = null;
    private errorImgUpload: string;

    private myUploads: MyUploadsComponent;
    private editFundComponent: EditFundComponent;
    private copyrightComp: CopyrightComponent;

    constructor(private id: string) {
        this.myUploads = new MyUploadsComponent();
        this.editFundComponent = new EditFundComponent();
        this.copyrightComp = new CopyrightComponent();
    }

    public render(): IJSLVNode {
        return <section class="banner-area upload-comp">
            <div class="container">
                <div class="row">
                    {this.submitted === false ? new LoadingComponent() : (this.submitted ? <div class="col-md-6 mb-10">
                        {this.errorImgUpload == null ? <h3>Fund erfolgreich hochgeladen</h3> :
                            <div>
                                <h3>Fund wurde hochgeladen - aber beim Hochladen der Bilder ist ein Fehler aufgetreten. <button class="genric-btn default-border"
                                    click={async () => { location.hash = "status/" + (await this.myUploads.getData())[0].fundId; }}>
                                    Bilder erneut hochladen</button></h3>
                                <div class="mt-10">Details: {this.errorImgUpload}</div>
                            </div>
                        }
                        {isInRole("expert") || isInRole("admin") ? null :
                            <div><i>Anmerkung: Ihr Fund wird von einem Experten überprüft bevor er in der Suche aufscheint.</i></div>}
                        <h3 class="mt-20">Weiteren Fund hochladen</h3>
                        <div><button class="genric-btn primary" click={() => {
                            this.submitted = null;
                            this.myUploads.getData().then((d) => this.editFundComponent.setFundOrt(d[0].fundOrtId));
                            // TODO: andere Daten auch noch übernehmen
                            // this.editFundComponent.set

                        }}>Gleicher Fundort</button>
                            <button class="genric-btn primary ml-20" click={() => {
                                this.submitted = null;
                                this.editFundComponent.setFundOrt();
                            }}>Neuer Fundort</button></div>
                    </div>
                        : <div class="col-md-6 mb-10 highlight-box" >
                            <h2>Neuen Fund melden</h2>
                            <p>Oder Fund <a href="#excel">per Excel hochladen</a></p>
                            {this.editFundComponent}
                            <h3>Bilder</h3>
                            <div>
                                <input id="up-files" name="up-files" type="file" multiple />
                            </div>
                            {this.copyrightComp}
                            <div class="mt-20">
                                <div class="alert-msg" style="text-align: left;"></div>
                                <button class="genric-btn primary" style="float: right;" click={this.upload}>Speichern</button>
                            </div>
                        </div>)}

                    <div class="col-md-6">
                        {this.myUploads}
                    </div>
                </div>
            </div>
        </section>;
    }

    public upload() {
        if (this.editFundComponent.getTaxon() == null) {
            alert("Bitte zuerst ein Taxon auswählen");
            return;
        }

        const fund: FundModel = {};
        const ort: FundOrtModel = this.editFundComponent.fundOrtId != null ? null : {};
        this.editFundComponent.getData(fund, ort);
        const files = (document.getElementById("up-files") as HTMLInputElement).files;
        this.submitted = false;

        const copyright = this.copyrightComp.getValue();

        ExpertController.Upload({ fund, ort }).then((fundId) => {

            if (files.length > 0) {
                const imgformData = new FormData();
                for (let i = 0; i < files.length; i++) {
                    imgformData.append("files", files[i]);
                }

                Axios.post("api/expert/uploadimages?fundId=" + fundId +
                    "&copy=" + encodeURIComponent(copyright ?? ""), imgformData, {}).then(() => {
                        this.submitted = true;
                        this.myUploads.reloadData();
                        refreshPendingCount();
                    }).catch((e) => {
                        this.errorImgUpload = e.response.data.title;
                        this.submitted = true;
                        this.myUploads.reloadData();
                        refreshPendingCount();
                    });
            } else {
                this.submitted = true;
                this.myUploads.reloadData();
                refreshPendingCount();
            }
            document.scrollingElement.scrollTop = 0;
        });

    }

}
